import { Button, FoodsIcon, Typography } from "@foodpilot/foods";
import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

type EmptyLeversProps = {
    onAdd?: () => void;
};

export const EmptyLevers = (props: EmptyLeversProps) => {
    const { onAdd } = props;
    const { t } = useTranslation();

    return (
        <Stack
            alignItems="center"
            gap={0.5}
            sx={(theme) => ({
                my: 2.5,
                p: 3,
                textAlign: "center",
                border: `1px dashed ${theme.palette.primary[600]}`,
                borderRadius: 1.5,
                backgroundColor: theme.palette.primary[50],
            })}
        >
            <Typography variant="big-bold">{t("settings.csr.overview.no_lever_title", "No lever yet.")}</Typography>
            <Typography>
                {t("settings.csr.overview.no_lever_description", "Add the first lever to this pillar.")}
            </Typography>
            {onAdd && (
                <Button
                    variant="text"
                    startIcon={<FoodsIcon icon="plus" size={1.5} />}
                    onClick={onAdd}
                    sx={(theme) => ({ color: theme.palette.primary[600] })}
                >
                    {t("settings.csr.overview.add_first_lever", "Add a first lever")}
                </Button>
            )}
        </Stack>
    );
};
